import { Route, Outlet } from 'react-router-dom';
import { CoachPage } from './components/CoachPage/CoachPage';

export const COACH_ROUTES = {
    COACH: { path: '/coach' },
};

export function configureCoachRoutes() {
    return [
        {
            routes: COACH_ROUTES,
            config: {
                removeAppShell: true,
            },
        },
    ];
}

export function getCoachRoutes() {
    return (
        <Route id="coach-routes" element={<Outlet />}>
            <Route path={COACH_ROUTES.COACH.path} element={<CoachPage />} />
        </Route>
    );
}
